import { FormattedNumber } from 'components/FormattedNumber/FormattedNumber';
import { useCreditsModalBLoC } from 'components/modals/CreditsModal/CreditsModal.bloc';
import { useObservableState } from 'observable-hooks';
import React from 'react';
import { CreditsModalTopupFormBalanceAfterStyle as S } from './CreditsModalTopupFormBalanceAfter.style';
import { Icon } from 'components/Icon/Icon';
import { HStack } from 'components/layouts/primitives/Stack/Stack';

export const CreditsModalTopupFormBalanceAfter: React.FC = () => {
  const { $formBalanceAndTotal, project, $mode } = useCreditsModalBLoC();
  const formBalanceAndTotal = useObservableState($formBalanceAndTotal);
  const mode = useObservableState($mode, '');

  return (
    <S.Container>
      {mode !== 'credit-purchase' && (
        <HStack align="center" justify="space-between">
          <HStack align="center" gap="gap2">
            <Icon icon="infoCircleLine" size={18} color="neutral600" />
            <S.Text>Minimum required to complete</S.Text>
          </HStack>
          <S.Text>{project && <FormattedNumber num={project?.amount} />}</S.Text>
        </HStack>
      )}
      <HStack align="center" justify="space-between">
        <HStack align="center" gap="gap2">
          <Icon icon="infoCircleLine" size={18} color="neutral600" className="cursor-pointer" />
          <S.Text>Balance after top-up</S.Text>
        </HStack>
        <S.Text data-testid="label-complete-transaction-balance-after">
          <FormattedNumber num={formBalanceAndTotal?.balanceAfterTopup || 0} />
        </S.Text>
      </HStack>
    </S.Container>
  );
};
